"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledText = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/styled-text"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // eslint-disable-next-line


var _default = function _default() {
  return (
    /*#__PURE__*/
    _react.default.createElement(_react.Fragment, null,
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      style: {
        marginBottom: 20
      },
      type: "h1"
    }, "Help me find my EIN or Canadian BN"),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      style: {
        marginBottom: 20
      },
      type: "h2"
    }, "For companies registered in the United States"),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      style: {
        marginBottom: 20
      }
    }, "A US-based company\u2019s employer identification number (EIN) is a nine-digit number (for example, 12-3456789) assigned by the IRS. Also known as a federal tax identification number, EINs are used by public corporations, private companies with employees, non-profits, and certain sole proprietors."),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      style: {
        marginBottom: 20
      }
    }, "You may be able to locate your company\u2019s EIN from previous tax returns, payroll paperwork, or documentation between your company and the IRS."),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      style: {
        marginBottom: 20
      }
    }, "Note: EIN is not a Social Security Number. Do not include SSN in this field."),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      style: {
        marginBottom: 20
      },
      type: "h2"
    }, "For companies registered in Canada"),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      style: {
        marginBottom: 20
      }
    }, "Canadian-based companies may be registered with a business number (BN) assigned by the Canada Revenue Agency. This is a unique, nine-digit number (for example 123456789) used to identify a business or legal entity for tax matters related to business in Canada. Companies may have a Canadian BN number if they interact with other federal, provincial, and municipal governments in Canada."),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, {
      style: {
        marginBottom: 20
      }
    }, "You may be able to locate your company\u2019s business number in materials related to federal incorporation, registrations for any CRA program accounts, or equivalent documentation."),
    /*#__PURE__*/
    _react.default.createElement(_styledText.default, null, "Note: Canadian BN is not a Social Security Number. Do not include SSN in this field."))
  );
};

exports.default = _default;